import Capacity from "pages/capacity-control";
import ForgotPassword from "pages/forgot-password";
import Login from "pages/login";
import Logout from "pages/login/Logout";
import Register from "pages/register";
import blackoutDatesRoutes from "routes/pages/blackoutDatesRoutes";
import couponsRoutes from "routes/pages/couponsRoutes";
import customersRoutes from "routes/pages/customersRoutes";
import deliveryRoutes from "routes/pages/deliveryRoutes";
import flavoursRoutes from "routes/pages/flavoursRoutes";
import homeRoutes from "routes/pages/homeRoutes";
import oneOffOrdersRoutes from "routes/pages/oneOffOrdersRoutes";
import pieOfTheMonthRoutes from "routes/pages/pieOfTheMonthRoutes";
import queueRoutes from "routes/pages/queueRoutes";
import subscriptionsRoutes from "routes/pages/subscriptionsRoutes";
import weeklySlotsRoutes from "routes/pages/weeklySlotsRoutes";

const routes = [
  // Home routes
  ...homeRoutes,
  // Flavours routes
  ...flavoursRoutes,
  // PieOfTheMonth routes
  ...pieOfTheMonthRoutes,
  // Customers routes
  ...customersRoutes,
  //Subscriptions routes
  ...subscriptionsRoutes,
  //One-off orders routes
  ...oneOffOrdersRoutes,
  //weekly-slots routes
  ...weeklySlotsRoutes,
  //coupons routes
  ...couponsRoutes,
  //queue routes
  ...queueRoutes,
  //delivery zone routes
  ...deliveryRoutes,
  //blackout dates routes
  ...blackoutDatesRoutes,
  // page for guest
  {
    path: `/`,
    exact: true,
    auth: false,
    component: Login,
  },
  // page for guest
  {
    path: `/register`,
    exact: true,
    auth: false,
    component: Register,
  },
  // page for guest
  {
    path: `/forgot-password`,
    exact: true,
    auth: false,
    component: ForgotPassword,
  },
  // page for guest
  {
    path: `/logout`,
    exact: true,
    auth: false,
    component: Logout,
  },
  //capcity control
  {
    path: `/capactiy-control`,
    exact: true,
    auth: true,
    component: Capacity,
  },
];

export default routes;
